import { TActions } from '../../../types/actions';
import { ETopBetsStatus, ITopBetsState } from './types';
import { initDefaultState } from './initDefaultState';
import { LOAD_TOP_BETS_FAIL, LOAD_TOP_BETS_START, LOAD_TOP_BETS_SUCCESS } from './actions';

export function topBets(state: ITopBetsState = initDefaultState(), action: TActions): ITopBetsState {
  switch (action.type) {
    case LOAD_TOP_BETS_START: {
      return {
        ...state,
        status: ETopBetsStatus.pending,
        errorCode: null,
      };
    }

    case LOAD_TOP_BETS_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        status: ETopBetsStatus.success,
      };
    }

    case LOAD_TOP_BETS_FAIL: {
      return {
        ...state,
        status: ETopBetsStatus.fail,
        errorCode: action.payload,
      };
    }

    default:
      return state;
  }
}
